<template>
    <div class="calendar-card">
      <img src="/images/promo/connect-features/calendar-card.svg" alt="Calendar card" />
    </div>
</template>

<script>
export default {};
</script>
